import { useSelector } from 'react-redux';

import { VisitsFlyout } from '../../../Visits';
import { RejectedFlyout } from '../../../Rejected';
import { AgenciesFlyout, AgenciesCreationFlyout } from '../../../Agencies';
import { getFlyout } from '../../selectors';
import { visitFlyout } from '../../../Visits/constants';
import { rejectedFlyout } from '../../../Rejected/constants';
import { agenciesFlyout, agenciesCreationFlyout } from '../../../Agencies/constants';

const Flyout = () => {
  const { show, target } = useSelector(getFlyout);

  return (
    <>
      <VisitsFlyout show={show && target === visitFlyout} />
      <RejectedFlyout show={show && target === rejectedFlyout} />
      <AgenciesFlyout show={show && target === agenciesFlyout} />
      <AgenciesCreationFlyout show={show && target === agenciesCreationFlyout} />
    </>
  );
};

export default Flyout;
